import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback } from 'react';
export function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    // @ts-ignore
    ref.current = value;
  }
}
export function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return useCallback(function (refValue) {
    setRef(refA, refValue);
    setRef(refB, refValue);
  }, [refA, refB]);
}

var withForwardedRef = function withForwardedRef(ChildComponent) {
  var wrappedComponent = forwardRef(function (props, ref) {
    return _jsx(ChildComponent, __assign({}, props, {
      forwardedRef: ref
    }));
  });
  var name = ChildComponent.displayName || ChildComponent.name;
  wrappedComponent.displayName = "withForwardedRef(".concat(name, ")");
  return wrappedComponent;
};

export default withForwardedRef;